export function clonePointerEventWithSrcElement(source: MouseEvent, targetEl: Element): MouseEvent {
  const cloned = new MouseEvent(source.type || 'mouseevent', {
    bubbles: true,
    cancelable: true,
    clientX: source.clientX,
    clientY: source.clientY,
    screenX: source.screenX,
    screenY: source.screenY,
    button: source.button,
    buttons: source.buttons,
    ctrlKey: source.ctrlKey,
    shiftKey: source.shiftKey,
    altKey: source.altKey,
    metaKey: source.metaKey
  })

  Object.defineProperty(cloned, 'target', { value: targetEl })
  Object.defineProperty(cloned, 'currentTarget', { value: targetEl })
  Object.defineProperty(cloned, 'srcElement', { value: targetEl })

  return cloned
}
